import CertifiedFieldFormValue from "../ReusableFormValues/CertifiedFieldFormValue";
import SubTypeDocumentSelector from "../SubTypeDocumentSelector";
import { formationDocumentTypesArray } from "./constants";

export type Props = {
  readonly: boolean;
  documentName?: string;
};

const FormationDocFormValues = ({ readonly, documentName = "" }: Props) => {
  return (
    <>
      <SubTypeDocumentSelector
        readonly={readonly}
        subTypeDocuments={formationDocumentTypesArray}
        placeholder="Select a formation document type"
        name="secondaryDocumentType"
        label="Document sub-type"
        documentName={documentName}
      />
      <CertifiedFieldFormValue readonly={readonly} />
    </>
  );
};

export default FormationDocFormValues;
